import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./list.module.css";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";

const AddUserForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [roleList, setRoleList] = useState([]);

  const { register, handleSubmit, control, setValue, watch, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      user_type: "",
    },
  });

  useEffect(() => {
    const fetchCategory = () => {
      axios.get(process.env.REACT_APP_API_URL + "v1/user-role-dd-list", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setRoleList(response.data.data);
      });
    };

    fetchCategory();
  }, [API_TOKEN]);

  useEffect(() => {
    if (editData) {
      setValue("name", editData?.name);
      setValue("email", editData?.email);
      setValue("phone", editData?.phone);
      setValue("user_type", editData?.user_type);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);

    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/users/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/users", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormMainRow}`}>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            control={control}
            {...register("name", { required: "This field is Required" })}
            render={({ field }) => (<TextField {...field} label="Full Name*" variant="outlined" />)}
          />
          {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">User Type*</InputLabel>
            <Controller
              control={control}
              {...register("user_type", {
                required: "This field is Required",
              })}
              render={({ field }) => (<Select label="User Type*" {...field}>
                {roleList?.map((i) => {
                  return (<MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>);
                })}
              </Select>)}
            />
          </FormControl>
          {errors.user_type && (<span className={`ErrorM`}>{errors?.user_type?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            control={control}
            {...register("email", {
              required: "This field is Required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" />)}
          />
          {errors.email && (<span className={`ErrorM`}>{errors?.email?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            control={control}
            {...register("phone", { required: "This field is Required" })}
            render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
          />
          {errors?.phone && (<span className={`ErrorM`}>{errors?.phone?.message}</span>)}
        </div>

        {!editData && (<>
          <div className={`${styles.FormGroupHalf} FormGroup`}>
            <Controller
              {...register("password", {
                required: "This field is Required",
              })}
              control={control}
              render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
            />
            {errors.password && (<span className={`ErrorM`}>{errors?.password?.message}</span>)}
          </div>
          <div className={`${styles.FormGroupHalf} FormGroup`}>
            <Controller
              {...register("conf_password", {
                required: "This field is Required",
                validate: (val) => {
                  if (watch("password") !== val) {
                    return "Your passwords do no match";
                  }
                },
              })}
              control={control}
              render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
            />
            {errors.conf_password && (<span className={`ErrorM`}>{errors?.conf_password?.message}</span>)}
          </div>
        </>
        )}
      </div>
      <div className="ButtonAction">
        <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
        <Button className="SubmitPopupBU" type="submit">{editData ? "Update" : "Add"}</Button>
      </div>
    </form>
  </>);
};

export default AddUserForm;